import "bootstrap";
import "bootstrap-select";
import "slick-carousel";
import AOS from "aos";
import "aos/dist/aos.css";

(function ($) {
  // sticky header
  window.onscroll = function () {
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
      $("header").addClass("scrolled");
    } else {
      $("header").removeClass("scrolled");
    }
  };

  // close mobile menu on window resize
  window.onresize = function () {
    if ($(window).width() > 430) {
      $(".menu-open").removeClass("is-active");
      $("header").removeClass("active");
      $(".mobile-menu-wrapper").removeClass("active");
      $("body").removeClass("menu-open");
    }
  };

  // On Dom Ready
  $(function () {
    AOS.init({
      disable: 'mobile',
      once: false,
      offset: 120,
      duration: 700,
    });

    // Mobile menu button
    $(".menu-open").on("click", function (e) {
      e.preventDefault();
      $(this).toggleClass("is-active");
      $("header").toggleClass("active");
      $(".mobile-menu-wrapper").toggleClass("active");
      $("body").toggleClass("menu-open");
    });

    // Mobile menu submenu toggle
    $(".mobile-menu-wrapper ul.mobile-menu li.menu-item-has-children > a > i").on("click", function (e) {
      e.preventDefault();
      $(this).parent().parent().find(".sub-menu").first().slideToggle();
      $(this).parent().toggleClass("active");
    });

    // Search form toggle
    $("header ul.primary-menu li .search-form .search-btn").on("click", function (e) {
      if (!$("header ul.primary-menu li .search-form").hasClass("active")) {
        e.preventDefault();
        $("header ul.primary-menu li .search-form").addClass("active");
        $("header ul.primary-menu li .search-form input.keyword").focus();
      }
    });

    // Hide search form when clicked outside
    $(document).on("click", function (e) {
      var $target = $(e.target);

      if (!$target.closest(".search-form").length) {
        $("header ul.primary-menu li .search-form").removeClass("active");
      }
    });

    //  Hero carousel events
    $(".hero-carousel .the-carousel").on("init", function (event, slick) {
      var firstSlide = $(".hero-carousel .the-carousel .the-slide").first();
      if (firstSlide.find("video.bg").length) {
        firstSlide.find("video.bg").trigger("play");
      }
    });

    $(".hero-carousel .the-carousel").on("beforeChange", function (event, slick, currentSlide, nextSlide) {
      $(".hero-carousel .the-carousel .the-slide .caption .the-title span").removeClass("aos-animate");

      // Start playing next video if there is one
      var nextVideo = $(".hero-carousel .the-carousel .the-slide").eq(nextSlide).find("video.bg");
      if (nextVideo.length) {
        nextVideo.trigger("play");
      }
    });

    $(".hero-carousel .the-carousel").on("afterChange", function (event, slick, currentSlide) {
      // Animate the title
      $(".hero-carousel .the-carousel .the-slide.slick-current .caption .the-title span").addClass("aos-animate");
      // Pause and rewind other videos
      $(".hero-carousel .the-carousel .the-slide")
        .not(".slick-current")
        .each(function () {
          var slideVideo = $("video.bg", this);
          if (slideVideo.length) {
            slideVideo.trigger("pause");
            slideVideo.get(0).currentTime = 0;
          }
        });
    });

    // Hero Carousel
    $(".hero-carousel .the-carousel").slick({
      autoplay: true,
      autoplaySpeed: 5000,
      dots: false,
      arrows: false,
      infinite: true,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      rows: 0,
      fade: true,
      pauseOnHover: false,
    });

    $(".scroll-down a").on("click", function (e) {
      e.preventDefault();
      var anchor_id = $(this).attr("href");
      $("html,body").animate({ scrollTop: $(anchor_id).offset().top }, "slow");
    });

    // Section - Project Spotlight Carousel
    var totalSlides = $(".section-project-spotlight .the-carousel .the-slide").length;
    var randomSlideIndex = Math.floor(Math.random() * totalSlides);

    $(".section-project-spotlight .the-carousel").slick({
      fade: true,
      autoplay: true,
      autoplaySpeed: 5000,
      dots: false,
      arrows: false,
      infinite: true,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      rows: 0,
      initialSlide: randomSlideIndex,
    });
    $(".section-project-spotlight .the-carousel")
      .on("beforeChange", function () {
        $(".section-project-spotlight .the-carousel .the-slide .bg").removeClass("aos-animate");
      })
      .on("afterChange", function (event, slick, currentSlide) {
        $(".section-project-spotlight .the-carousel .the-slide.slick-current .bg").addClass("aos-animate");
      });

    // --- next/perv functionality
    $(".section-project-spotlight .the-carousel .the-slide .the-content .slide-navigation li button.next-slide").on("click", function (e) {
      e.preventDefault();
      $(".section-project-spotlight .the-carousel").slick("slickNext");
    });
    $(".section-project-spotlight .the-carousel .the-slide .the-content .slide-navigation li button.prev-slide").on("click", function (e) {
      e.preventDefault();
      $(".section-project-spotlight .the-carousel").slick("slickPrev");
    });

    // Section - Meet our team Carousel
    $(".section-team .the-carousel").slick({
      fade: true,
      autoplay: true,
      autoplaySpeed: 5000,
      dots: false,
      arrows: false,
      infinite: true,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      rows: 0,
    });

    // --- next/perv functionality
    $(".section-team .the-carousel .the-slide .slide-navigation li button.next-slide").on("click", function (e) {
      e.preventDefault();
      $(".section-team .the-carousel").slick("slickNext");
    });
    $(".section-team .the-carousel .the-slide .slide-navigation li button.prev-slide").on("click", function (e) {
      e.preventDefault();
      $(".section-team .the-carousel").slick("slickPrev");
    });

    // Section - Latest News Carousel
    $(".section-latest-news .the-carousel").slick({
      autoplay: false,
      autoplaySpeed: 5000,
      dots: false,
      arrows: false,
      infinite: true,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      adaptiveHeight: false,
      rows: 0,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 1200,
          settings: "unslick",
        },
      ],
    });

    // Section - Client Testomonials Carousel
    $(".section-client-testimonials .the-carousel").slick({
      autoplay: true,
      autoplaySpeed: 10000,
      dots: true,
      arrows: false,
      infinite: true,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      rows: 0,
    });

    // Photoslider - Block
    $(".photoslider .the-carousel").slick({
      autoplay: false,
      autoplaySpeed: 5000,
      dots: false,
      arrows: true,
      infinite: true,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      rows: 0,
      prevArrow: '<button class="prev-slide" type="button"><span class="sr-only">Previous Slide</span><i class="far fa-long-arrow-left"></i></button>',
      nextArrow: '<button class="next-slide" type="button"><span class="sr-only">Next Slide</span><i class="far fa-long-arrow-right"></i></button>',
    });

    position_photoslider_arrows();

    // Position photo slider arrows
    $(window).on("resize", function () {
      position_photoslider_arrows();
    });
    $(window).on("load", function () {
      position_photoslider_arrows();
    });

    function position_photoslider_arrows() {
      var image_height = $(".photoslider .the-carousel .the-slide .the-image").height();
      var button_height = $(".photoslider .the-carousel .slick-arrow").height();
      $(".photoslider .the-carousel .slick-arrow").css({
        top: image_height - button_height,
      });
    }

    // Read more button functionality
    if ($(".more-content").length && $(".more-content").html() !== "") {
      $('<a href="#" class="more-link btn btn-primary">Read More</a>').insertAfter(".more-content");
    }
    $(document).on("click", ".more-link", function (e) {
      e.preventDefault();
      $(this).prev().slideToggle();
      if ($(this).text() == "Read More") $(this).text("Read Less");
      else $(this).text("Read More");
    });

    // Smooth scroll to the linked section
    $("a.scroll-link, .scroll-link a").on("click", function (e) {
      e.preventDefault();
      var anchor_id = $(this).attr("href");
      $("html,body").animate({ scrollTop: $(anchor_id).offset().top - 100 }, "slow");
    });

    // Expand / Collaps Related Services
    $(".related-services-tree ul.services-list > li a.expand-collapse-btn").on("click", function (e) {
      e.preventDefault();
      $(this).parent().parent().find(".children").slideToggle();
      $(this).toggleClass("active");
    });

    // Single project photos carousel
    $(".single-project-section .project-photos .the-carousel").slick({
      autoplay: true,
      autoplaySpeed: 5000,
      dots: true,
      arrows: false,
      infinite: true,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      rows: 0,
    });

    // Ajax load more records
    $(".loadmore-btn-wrapper .btn").on("click", function () {
      var button = $(this);
      var button_text = button.text();
      var current_page = $("#the_current_page").val();
      var max_page = $("#the_max_page").val();
      var data_type = $("#data_type").val();

      var data = {
        action: "loadmore_records",
        data_type: data_type,
        query: $("#the_query").val(),
        page: current_page,
      };

      $.ajax({
        url: pare_loadmore_params.ajaxurl, // AJAX handler
        data: data,
        type: "POST",
        beforeSend: function (xhr) {
          button.text("Loading..."); // change the button text, you can also add a preloader image
        },
        success: function (data) {
          if (data) {
            button.text(button_text);
            $(".the-listing .row").append(data);

            current_page++;
            $("#the_current_page").val(current_page);

            if (current_page == max_page) $(".loadmore-btn-wrapper").remove(); // if last page, remove the button
          } else {
            button.remove(); // if no data, remove the button as well
          }
        },
      });
    });

    // Ajax random testimonials
    $(".section-client-testimonials").each(function () {

      var testimonialSection = $(this);

      if( $(this).data('testimonials-source') != 'random' ){
        return;
      }

      var data = {
        action: "random_testimonials"
      };

      $.ajax({
        url: pare_loadmore_params.ajaxurl, // AJAX handler
        data: data,
        type: "POST",
        beforeSend: function (xhr) {
          //testimonialSection.addClass('loading');
        },
        success: function (data) {
          if (data) {
            $(data).filter('.the-slide').each(function(index) {
              var slideHTML = '<div class="the-slide">' + $(this).html() + '</div>';
              $(".the-carousel", testimonialSection).slick( 'slickAdd', slideHTML );
            });
          }
          //testimonialSection.removeClass('loading');
        },
      });
    });

    // Custom file upload element
    $('.custom-file-upload input[type="file"]').on("change", function (e) {
      if ($(this).val()) {
        $(this).parent().parent().find("label").html(e.target.files[0].name);
      } else {
        $(this).parent().parent().find("label").html("No file chosen");
      }
    });
    $('.custom-file-upload input[type="button"]').on("click", function (e) {
      $(this).parent().find('input[type="file"]').trigger("click");
    });

    // Append class to gutenberg columns containing image
    $(".wp-block-columns").each(function (index, element) {
      if ($(element).find(".wp-block-column").length == 2) {
        if ($(element).find(".wp-block-column:nth-child(2)").find("img").length > 0) {
          $(element).addClass("has-image-in-2nd-column");
        }
      }
    });
  });

  // Submit search form on filters select (bootstrap dropdown)
  $(".section-search-header").on("changed.bs.select", function (e, clickedIndex, isSelected, previousValue) {
    $(".section-search-header .search-form").trigger("submit");
  });

  // Show gated content on successfully form submission
  var wpcf7Elm = document.querySelector(".before-gated-content .wpcf7");

  if (wpcf7Elm !== null) {
    wpcf7Elm.addEventListener(
      "wpcf7mailsent",
      function (event) {
        $(".before-gated-content").hide();
        $(".after-gated-content").show();
      },
      false
    );
  }
})(jQuery);
